import type { JSX } from 'react';
import React from 'react';

import Tooltip from '@/ui/components/Tooltip';

import OverLabel from './OverLabel';

interface Props {
  value: string | number | undefined | JSX.Element;
  label: string | number | undefined | JSX.Element;
  expectedValue: string | number | undefined | JSX.Element;
}

const ComparedValue = ({ value, label, expectedValue }: Props): JSX.Element => {
  return (
    <OverLabel label={label}>
      <Tooltip tooltipContent={`Expected: ${expectedValue}`}>
        <span className="flex items-center">
          <span>{value}</span>
          {value != expectedValue && <div className="ml-2 w-2.5 h-2.5 bg-red-600 rounded-full" />}
        </span>
      </Tooltip>
    </OverLabel>
  );
};

export default ComparedValue;
